<template>
  <div>
    <a-menu mode="horizontal" :key="routeValue" :selectable="false" @click="titleClick"
            @openChange="handleMenuOpenChange">
      <template v-for="menu in recursiveMenus">
        <a-sub-menu :key="menu.id" @mouseenter="handleMouseEnter(menu)" @mouseleave="handleMouseLeave(menu)"
                    @titleClick="titleClick" :popupOffset="[1, 2]">
          <span slot="title" style="position: relative">
            <span :style="{paddingRight:(menu.id==='0'||menu.id==='-2')?'15px':'',fontWeight:'800'}">{{ menu.title }}</span>
              <right-icon v-show="menu.id==='0'"
                          :style="{position: 'absolute',top:'-3px' ,right:'-6px',transition: 'transform 0.3s', transform: isOpen? 'rotate(-90deg)' : 'rotate(0deg)' }"/>
              <search-icon v-show="menu.id==='-2'"
                           :style="{ position: 'absolute',top:'-2px' ,right:'-6px'}"/>

            <div v-if="isOpen&&menu.id==='0'"
                 :style="{ width:'82px',height:'2px', background:'#FFFFFF', position: 'absolute',bottom:'-7px' ,left:'-2px'}">
            </div>
          </span>
          <template v-for="child in menu.children">
            <template v-if="child.children">
              <a-sub-menu :key="child.id" @mouseenter="handleMouseEnter(child)" @mouseleave="handleMouseLeave(child)"
                          @titleClick="titleClick" :popupOffset="[0, 0]">
                <span slot="title">{{ child.title }}
                  <a-icon type="right"
                          :style="{ fontSize:'12px', transition: 'transform 0.3s', transform: child.isMenuOpen? 'rotate(0deg)' : 'rotate(90deg)' }"></a-icon>
                </span>
                <template v-for="subChild in child.children">
                  <a-menu-item :key="subChild.id">{{ subChild.title }}</a-menu-item>
                </template>
              </a-sub-menu>
            </template>
            <template v-else>
              <a-menu-item :key="child.id">{{ child.title }}</a-menu-item>
            </template>
          </template>
        </a-sub-menu>
      </template>
    </a-menu>
  </div>
</template>

<script>
import EventBus from '../router/event-bus'
import RightIcon from './RightIcon.vue'
import SearchIcon from './SearchIcon.vue'

export default {
  name: 'RecursiveMenu',
  props: ['menuItems', 'routeValue'],
  components: {RightIcon, SearchIcon},
  data () {
    return {
      isOpen: false,
      current: ['-1'],
      selectedKeys: []
    }
  },
  computed: {
    recursiveMenus () {
      return this.buildRecursiveMenus(this.menuItems)
    }
  },
  created () {
    this.current = [this.routeValue]
  },
  methods: {
    toggleSubMenu (item) {
      this.$forceUpdate()
      item.isMenuOpen = !item.isMenuOpen
    },
    handleMouseEnter (item) {
      console.log(item)
      this.$forceUpdate()
      item.isMenuOpen = true
    },
    handleMouseLeave (item) {
      this.$forceUpdate()
      item.isMenuOpen = false
    },
    buildRecursiveMenus (menus) {
      const recursiveMenus = []
      for (const menu of menus) {
        const recursiveMenu = {...menu}
        if (recursiveMenu.children) {
          recursiveMenu.children = this.buildRecursiveMenus(recursiveMenu.children)
        }
        recursiveMenus.push(recursiveMenu)
      }
      return recursiveMenus
    },

    titleClick ({key}) {
      this.current = [key]
      this.selectedKeys = []
      let routeName = key === 10000000 ? 'PhotoGraph' : key === '-2' ? 'Search' : key === '-3' ? 'AboutUs' : 'Design'
      if (routeName === 'Design') {
        EventBus.$emit('customEvent', key)
      }
      if (routeName === 'PhotoGraph') {
        EventBus.$emit('PhotoEvent', key)
      }
      if (this.$route.name !== routeName) {
        this.$router.push({name: routeName})
      }
    },
    handleMenuOpenChange (openKeys) {
      this.isOpen = openKeys.some(key => {
        if (typeof key === 'string') {
          return key.split('-').length === 1
        }
        return false
      })
    },
  }
}
</script>
<style lang="less">


@keyframes arrow-up-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(90deg);
  }
}

@keyframes arrow-down-animation {
  0% {
    transform: rotate(90deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RecursiveMenu.vue